export default "__VITE_ASSET__BQSE3Q$M__"